import React from 'react';
import styled from 'styled-components';
import { BoxTitle, MainHomeBox } from '../common/commonStyle';
import {
  TITLESEC_DESIGN_TYPE,
  TITLESEC_DESIGN_TYPE_VALUE,
} from '@typings/mainHome/titleSecDesign';

const Container = styled.div<{
  mobileMaxHeight?: string;
  $isBackground?: boolean;
}>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 0;
  height: 100%;

  &::-webkit-scrollbar {
    display: none;
  }
  @media (max-width: 480px) {
    max-height: ${({ mobileMaxHeight }) => mobileMaxHeight};
    overflow-y: auto;
  }
`;

const ScrollSec = styled.div`
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  margin: auto 0;

  &::-webkit-scrollbar {
    display: none;
  }
`;

type Props = {
  titleDesignType?: TITLESEC_DESIGN_TYPE_VALUE;
  title?: string;
  children?: any;
  style?: React.CSSProperties;
  maxHeight?: string;
  mobileMaxHeight?: string;
  isBackground?: boolean;
};
function TitleWidgetSec({
  titleDesignType = TITLESEC_DESIGN_TYPE.HEADER,
  title,
  children,
  style,
  maxHeight,
  mobileMaxHeight,
  isBackground = true,
}: Props) {
  const isHeaderType = titleDesignType === TITLESEC_DESIGN_TYPE.HEADER;
  // 헤더 타입이면 본문을 Container로, 그 외에는 MainHomeBox로 스크롤 영역 구성
  const BoxComponent = isHeaderType ? MainHomeBox : Container;
  const ScrollComponent = isHeaderType ? Container : MainHomeBox;

  return (
    <BoxComponent
      $isBackground={isBackground}
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        ...style,
      }}
    >
      {title && (
        <BoxTitle type={isHeaderType ? 'transparent' : 'default'}>
          {title}
        </BoxTitle>
      )}
      <ScrollComponent
        $isBackground={isBackground}
        style={{ maxHeight }}
        mobileMaxHeight={mobileMaxHeight}
      >
        <ScrollSec>{children}</ScrollSec>
      </ScrollComponent>
    </BoxComponent>
  );
}

export default TitleWidgetSec;
